/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : AUTH NEW INVITATION SENT : STYLES --------------- ++++++++++ */
export default theme => ({
    newinvitationsent:{
        '& h3':{
            fontSize: pxToEm(32),
            fontWeight: 500,
            marginBottom: pxToEm(16)
        },
        '& li':{
            textAlign: 'left',
            fontSize: pxToEm(16),
            fontWeight: 500,
            lineHeight: pxToEm(16),
            marginBottom: pxToEm(14)
        },
        '& .sendagain':{
            color: theme.color.neutral.medium.swatch,
            fontSize: pxToEm(16),
            fontWeight: 500
        },
        '& .contactus':{
            marginTop: pxToEm(20),
            textAlign: 'center',
            fontSize: pxToEm(16),
            fontWeight: 500,
            '& .link':{
                color: theme.color.primary.medium.swatch
            }
        }
    }
});
